import { Theme } from '@mui/material';

import { createStyles, makeStyles } from '@mui/styles';

export const styles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeIcon: { padding: 0 },
    dialogContent: { width: 500 },
    formControl: { width: '100%' },
  }),
);
